import { AbstractOptionsMenuProperties } from "@lib/titan2/dist/game/view/properties/AbstractOptionsMenuProperties";
import { SlingoStyle } from "../style/SlingoStyle";
/*
 * OptionsProperties.ts
 */
export class OptionsProperties extends AbstractOptionsMenuProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.SFXButtonProperties.id = SlingoStyle.OPTIONS_MENU_SOUND_BUTTON;
        this.SFXButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_SOUND_BUTTON;
        this.backgroundSoundButtonProperties.id = SlingoStyle.OPTIONS_MENU_MUSIC_BUTTON;
        this.backgroundSoundButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_MUSIC_BUTTON;
        /*this.optionsButtonProperties.id = SlingoStyle.OPTIONS_TOGGLE_BUTTON;
        this.optionsButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_TOGGLE_BUTTON;

        this.homeButtonProperties.id = SlingoStyle.OPTIONS_MENU_HOME_BUTTON;
        this.homeButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_HOME_BUTTON;
        this.helpButtonProperties.id = SlingoStyle.OPTIONS_MENU_HELP_BUTTON;
        this.helpButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_HELP_BUTTON;
        this.payTableButtonProperties.id = SlingoStyle.OPTIONS_MENU_PAY_TABLE_BUTTON;
        this.payTableButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_PAY_TABLE_BUTTON;
        this.depositButtonProperties.id = SlingoStyle.OPTIONS_MENU_DEPOSIT_BUTTON;
        this.depositButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_DEPOSIT_BUTTON;
        this.responsibleGamingButtonProperties.id = SlingoStyle.OPTIONS_MENU_RESPONSIBLE_GAMING_BUTTON;
        this.responsibleGamingButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_RESPONSIBLE_GAMING_BUTTON;
        this.dghButtonProperties.id = SlingoStyle.OPTIONS_MENU_GAME_HISTORY_BUTTON;
        this.dghButtonProperties.movieClipProperties.id = SlingoStyle.OPTIONS_MENU_GAME_HISTORY_BUTTON;*/
    }
}
//# sourceMappingURL=OptionsProperties.js.map